import { Tooltip, withStyles } from '@material-ui/core';

export const TextOnlyTooltip = withStyles({
  tooltip: {
    backgroundColor: 'white',
    boxShadow: '0 3px 6px rgba(0, 0, 0, 0.16)',
    color: '#000',
    padding: '12px 10px',
    fontSize: 14,
  },
})(Tooltip);
